export const requestDataVehiculo = (datos) => {
  const tipoVehiculoId = Number(datos?.tipoVehiculoId ?? datos?.tipoVehiculoModel?.id ?? 0);
  return {
    placa: datos.placa,
    nombre: datos.nombre,
    cantidadCinturones: Number(datos.cantidadCinturones ?? 1),
    tipoVehiculo: datos.tipoVehiculo,
    tipoVehiculoModel: tipoVehiculoId ? { id: tipoVehiculoId } : null,
    estado: datos.estado ?? true,
    empresasModel: {
      id: Number(datos?.empresasModel?.id ?? datos?.empresaId ?? datos?.empresa ?? 0),
    },
  };
};
